
import jsPDF from "jspdf";
import "jspdf-autotable";

export const ExportKPIPdf = (data) => {
    const doc = new jsPDF();

    // Format tanggal
    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        return new Date(dateString).toLocaleDateString("id-ID", options);
    };

    // Header PDF
    doc.setFontSize(16);
    doc.text(data.title, 105, 20, { align: "center" });

    // Informasi utama
    doc.setFontSize(11);
    const labels = [
        "Kode Karyawan",
        "Nama Lengkap",
        "Divisi",
        "Tanggal",
        "Deskripsi",
        "KPI Min",
        "KPI Maks",
    ];
    const values = [
        data.users.users_code || "N/A",
        data.users.name,
        data.division.name,
        formatDate(data.created_at),
        data.desc,
        data.kpi_value_min,
        data.kpi_value_max,
    ];

    // Atur posisi awal dan padding
    let startX = 5;
    let startY = 40;
    const labelWidth = 40; 
    labels.forEach((label, index) => {
        doc.text(`${label}`, startX, startY + index * 10); 
        doc.text(`: ${values[index]}`, startX + labelWidth, startY + index * 10); 
    });

    // Data tabel
    const tableColumns = [
        "No",
        "Performance Area",
        "Performance Indicators",
        "Weight",
        "Target",
        "Actual",
        "Score",
        "Final Score",
        "Status",
    ];
    const tableRows = data.kpi_task.map((task, index) => [
        index + 1,
        task.task.perfomance_area,
        task.task.perfomance_indicators,
        task.task.weight,
        task.task.target,
        task.actual,
        task.score,
        task.final_score,
        task.task.is_maximal == true ? "Maksimal" : "Minimal",
    ]);

    let finalY = startY + labels.length * 10 + 10; // Awal tabel setelah informasi
    doc.autoTable({
        head: [tableColumns],
        body: tableRows,
        startY: finalY,
        margin: { top: 10, left: 5, right: 5, bottom: 5 },
    });

    // Tanda tangan
    const pageHeight = doc.internal.pageSize.height;
    finalY = doc.lastAutoTable.finalY + 10;

    if (finalY + 50 > pageHeight) {
        doc.addPage();
        finalY = 10;
    }

    const signatureTable = [
        [
            { content: "Proposed By", styles: { halign: "center", fontStyle: "bold" } },
            { content: "Approved By", colSpan: 2, styles: { halign: "center", fontStyle: "bold" } },
            { content: "Acknowledged By", colSpan: 2, styles: { halign: "center", fontStyle: "bold" } },
        ],
        [
            { content: "Pemegang Jabatan", styles: { halign: "center", fontStyle: "bold" } },
            { content: "Atasan Langsung", styles: { halign: "center", fontStyle: "bold" } },
            { content: "Atasan Tidak Langsung", styles: { halign: "center", fontStyle: "bold" } },
            { content: "HR Manager", styles: { halign: "center", fontStyle: "bold" } },
            { content: "Director", styles: { halign: "center", fontStyle: "bold" } },
        ],
        [
            { content: "", styles: { halign: "center", minCellHeight: 20 } }, // Kolom kosong untuk tanda tangan
            { content: "", styles: { halign: "center", minCellHeight: 20 } }, // Kolom kosong
            { content: "", styles: { halign: "center", minCellHeight: 20 } }, // Kolom kosong
            { content: "", styles: { halign: "center", minCellHeight: 20 } }, // Kolom kosong
            { content: "", styles: { halign: "center", minCellHeight: 20 } }, // Kolom kosong
        ],
        [
            { content: "Nama", styles: { halign: "center" } },
            { content: "Nama", styles: { halign: "center" } },
            { content: "Nama", styles: { halign: "center" } },
            { content: "Nama", styles: { halign: "center" } },
            { content: "Nama", styles: { halign: "center" } },
        ],
    ];

    doc.autoTable({
        body: signatureTable,
        startY: finalY,
        theme: "grid",
        styles: { fontSize: 10, cellPadding: 2 },
        margin: { top: 10, left: 5, right: 5, bottom: 5 },
        rowStyles: { minCellHeight: 5 }, // Atur tinggi minimal untuk baris tanda tangan
    });

    // Simpan PDF
    doc.save(`${data.title.replace(/ /g, "_")}.pdf`);
};
